import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    VStack,
    HStack,
    Text,
    Button,
    Avatar,
    Box,
    Circle,
    Icon,
    IconButton,
    Center,
    Badge,
    Spinner,
    Progress,
} from '@chakra-ui/react';
import React, { Suspense } from 'react';
import { IntegrationViewBaseConfig } from '../../../base';
import { CallOverlayViewProps } from './callOverlayProps';
import { AiOutlineClose } from 'react-icons/ai';
import { FiMic, FiMicOff, FiPhoneOff, FiVideo, FiVideoOff } from 'react-icons/fi';
import { Reference } from '../../../../../../../base';
import { CallUpsertContainerProps } from '../upsert';

export function createCallOverlayView(
    config: IntegrationViewBaseConfig & {
        Container: {
            Call: {
                Upsert: React.FC<CallUpsertContainerProps>;
            };
        };
    }
): React.FC<CallOverlayViewProps> {
    const {
        Container: {
            Call: { Upsert: CallUpsertContainer },
        },
    } = config;
    return (props) => {
        return (
            <Modal
                isOpen={props.isOpen}
                onClose={props.onClose}
                isCentered={true}
                closeOnOverlayClick={false}
                returnFocusOnClose={false}
                closeOnEsc={false}
                autoFocus={false}
            >
                <ModalOverlay />
                <ModalContent
                    bg="black"
                    position="relative"
                    p={0}
                    overflowY="hidden"
                    _focus={{ outline: 'none' }}
                    _focusVisible={{ outline: 'none' }}
                    w="fit-content"
                    h="fit-content"
                    maxW="95vw"
                    maxH="90vh"
                    transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                >
                    <ModalBody bg="whiteAlpha.100" p={0} position="relative">
                        <Suspense
                            fallback={
                                // TODO centralize loading and connecting state rendering
                                <></>
                            }
                        >
                            <CallUpsertContainer {...props.upsert} />
                        </Suspense>
                    </ModalBody>
                </ModalContent>
            </Modal>
        );
    };
}
